import Form from './Form';

export default Form;



// WEBPACK FOOTER //
// ./assets/app/common/components/Form/index.js